import { render, staticRenderFns } from "./iconInvoice.vue?vue&type=template&id=8e5e0694"
import script from "./iconInvoice.vue?vue&type=script&lang=js"
export * from "./iconInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports